import Image from "next/image";

import { cn } from "~/lib/utils";
import Overline from "~/componentsDS/Typography/Overline";

type ReviewsRatingNewProps = {
    size?: "md" | "sm";
    className?: string;
};

const ReviewsRatingNew = ({ size = "md", className }: ReviewsRatingNewProps) => {
    return (
        <div className={cn("flex md:items-center mt-2 md:mt-0 tracking-[1.28px] text-primary300 leading-[20px] uppercase pt-1",className)}>
            <Image
                width={88}
                height={15}
                className="h-[15px] mr-[8px]"
                src="https://res.cloudinary.com/dirscuuhp/image/upload/v1782817929/Stars_3_t186j9.webp"
                alt="rating"
            />
            <Overline size={size} weight="500" className="text-center text-primary300">
                4.9/5 (5,695 Reviews)
            </Overline>
        </div>
    );
};

export default ReviewsRatingNew;